/* eslint-disable no-template-curly-in-string */
import flatten from 'flat';

export const strings = {
  basic: {
    a: 'a',
    as: 'as',
    learnMore: 'Learn more',
  },
  admin: {
    classProfile: {
      classOwners: 'class owners',
      goToClass: 'Go to class',
      joinClass: 'Join this class',
      lastAnnouncement: 'Last announcement',
      leaveClass: 'Leave this class',
      memberCount: 'Showing {memberCount} of the {count} {type}',
      moreActions: 'More actions',
      noRole: 'No role',
      participants: 'participants',
      removeMemberModal: {
        cancelButton: 'Cancel',
        confirmButton: 'Remove',
        errorMessage: 'An error occured removing user {memberName} from {groupName}.',
        remove: 'Remove from class',
        successMessage: '{memberName} was removed from {groupName}',
        warningText: 'Remove participant?',
        warningSubtext:
          'This person will be permanently removed, and won’t receive announcements or be available for direct messaging anymore.',
        messageHistoryWarning:
          'When you remove them, You will no longer have access to their message history. Please send their message history to yourself before completing this action.',
      },
      removeOwnerModal: {
        cancelButton: 'No, never mind',
        confirmButton: 'Yes, remove',
        errorMessage: 'An error occured removing {groupName} ownership from {ownerName}.',
        remove: 'Remove as owner',
        successMessage: '{ownerName} successfully removed as owner of {groupName}',
        warningText: 'Are you sure?',
        warningSubtext: 'Please confirm the removal of {ownerName} as an owner of {groupName}.',
      },
      viewMore: 'View more announcements',
    },
    classSettings: {
      lockSettings: {
        District:
          "Class settings will be locked. People won't be able to change class settings unless you unlock the settings for the organization.",
        label: 'Lock class settings across your organization',
        modal: {
          title: 'Lock settings for all {activeGroupCount} classes?',
          text: 'Class owners in your organization will no longer be able to change their class settings.',
        },
        locked: {
          school:
            "Class settings have been locked by the Administrator at your district. Please reach out to your Organization's Administrator to update these settings",
          class:
            "Class settings have been locked by the Administrator at your school. Please reach out to your Organization's Administrator to update these settings.",
        },
        School:
          "Class settings will be locked. People won't be able to change class settings unless you unlock the settings for the organization.",
      },
      backfill: {
        District:
          'Class settings for all existing classes in your organization will be updated to match the default class settings.',
        label: 'Apply changes to all existing classes',
        modal: {
          text: 'This will change the class settings for all of the classes in {organizationName}.',
          title: 'Apply changes to {activeGroupCount} classes?',
        },
        School:
          'Class settings for all existing classes in your organization will be updated to match the default class settings.',
      },
      backfillAndLockSettingsModal: {
        title: 'Apply changes and lock settings for all {activeGroupCount} classes?',
        text: 'This will change the class settings for all of the classes, and class owners in your organization will no longer be able to change their class settings.',
      },
      tab: {
        archiving: 'Archiving',
        classCode: 'Class code',
        classInfo: 'Class information',
        className: 'Class name',
        classOwners: 'Class {count, plural, one {owner} other {owners}}',
        classOwnersSubtext:
          'Class owners can send announcements and individual messages to participants.',
        classOwnersCanEdit: 'Class owners',
        classOwnersCanEditSubtext:
          'Class owners can see and send messages to class participants.  Owners can only be removed by themselves or by an administrator.',
        info: 'Information',
        leave: 'Leave class',
        school: 'School',
        leaveWarning: 'You will no longer receive announcements from {groupName}.',
      },
      addGroupOwnerModal: {
        body: 'Not seeing the person you’d like to add?',
        bodyNoOwners:
          'To be promoted to class owner, participants must be 13 or older with a Remind account created online or in the app.',
        bodyNoOwners2: 'Nobody is currently eligible to become a co-owner.',
        confirmSubtext:
          'All class owners have the same controls. Owners can only be removed by themselves or by an administrator.',
        confirmText:
          'Are you sure you want to add {entity} class {ownersCount, plural, one {owner} other {owners}}?',
        errorText: 'An error occured adding user to {name}',
        link: 'Add them',
        successText: 'Class {ownersCount, plural, one {owner} other {owners}} added',
      },
      unsavedChangesModal: {
        title: 'You haven’t saved your changes',
        text: 'If you want to apply changes to existing classes at your organization, go back and click save at the bottom of your screen.',
      },
    },
    confirmDialog: {},
    ed2: {
      overview: {
        remindCommunity: 'My Remind community',
        reachability: {
          headerTitle: 'Reachability',
          preferredLanguage: 'Percent of users who have set their preferred language',
          reachableCommunity: 'Percent of users reachable via SMS, email or app',
          pctReceivedMessages: 'Percent of sent messages that are delivered successfully',
        },
        adoptionAndUsage: {
          headerTitle: 'Adoption and usage',
          teachersAdminsSendingMessages:
            'Percent of teachers and admin who sent messages last month',
          messagesOverTime: 'Percent of parents and students who received messages last month',
          adoptionOverviewTotalMsgsSent: 'Total messages sent last month',
        },
        topSchools: 'Top schools with largest percentage of users sending messages',
        test: 'Test dashboard',
      },
      stats: {
        remindCommunity: {
          navTitle: 'Community overview',
          subtitle: 'Breakdown of SIS-linked status and roles among all users',
          title: "Who's in my Remind Community?",
        },
        preferredLanguage: {
          navTitle: 'Preferred language',
          subtitle:
            'Number of people who have their preferred language set (chart shows top 10 language preferences)',
          title: 'Are people setup to receive messages in their preferred language?',
        },
        reachableCommunity: {
          navTitle: 'Reachability',
          subtitle:
            'Percentage of users who are set up to receive Remind messages by SMS, App and Email',
          title: 'How is my community reachable?',
        },
        pctReceivedMessages: {
          navTitle: 'Messages received',
          subtitle: 'Percentage of sent messages that users have received',
          title: 'How did people receive the messages that were sent to them?',
        },
        messagesOverTime: {
          navTitle: 'Messages received',
          subtitle: 'Percentage of sent messages that users have received over time',
          title: 'What does message delivery look like over time?',
        },
        teachersAdminsSendingMessages: {
          navTitle: 'Messages sent',
          subtitle: 'Number of teachers and admins who send at least 1 message per time period',
          title: 'Are teachers and admins sending messages?',
        },
        engagement: {
          navTitle: 'Engagement',
        },
      },
      noDataModal: {
        confirmButton: 'Got it',
        notAvailable: {
          title: 'Data not available',
          subtext:
            'There is no data available since the historical data that is currently available begins on January 1, 2022. Pick a date range that starts and ends after January 1, 2022 in order to see data.',
        },
        notAvailableYet: {
          title: 'Data not available yet',
          subtext:
            "Data will be refreshed nightly, so any day-of information will not be available. Therefore, certain date filters that contain day-of information (like the 'Today' filter) will not populate chart data.",
        },
        partiallyAvailable: {
          title: 'Data partially available',
          subtext:
            'Data is only partially available since the historical data that is currently available begins on January 1, 2022. Pick a date range that starts and ends after January 1, 2022 in order to see a complete data set.',
        },
      },
      surveyLink: 'Feedback on the new dashboard',
    },
  },
  common: {
    buttons: {
      accept: 'Accept',
      applyChanges: 'Apply changes',
      back: 'Back',
      cancel: 'Cancel',
      close: 'Close',
      confirm: 'Confirm',
      continue: 'Continue',
      create: 'Create',
      decline: 'Decline',
      edit: 'Edit',
      goBack: 'Go back',
      no: 'No',
      next: 'Next',
      previous: 'Previous',
      support: 'Contact Support',
      save: 'Save',
      send: 'Send',
      update: 'Update',
      yes: 'Yes',
      ok: 'Ok',
      on: 'On',
      off: 'Off',
    },
    byDate: 'by {date}',
    contactUs: 'Contact us',
    labels: {
      day: 'Day',
      duration: 'Session Length',
      startDate: 'Start date',
      timezone: 'Time ({timezone})',
    },
    links: {
      learnMore: 'Learn more',
    },
    logout: 'Log out',
    nameSeparator: ', ',
    placeholders: {
      startDate: 'Select a start date',
    },
    defaultLoadingError: 'Sorry! We hit a snag.',
  },
  distanceLearning: {
    waitingRoom: {
      browserAccess:
        'For others to hear and see you, you need to give your browser access to your microphone and camera.',
      disabledAV: 'Audio and video are disabled',
      waitingForHost: 'Waiting for a host to start the meeting...',
      aboutToStart: 'You’re about to start a video session.',
      microphoneSettings: 'You can change your microphone and camera settings below.',
      startSession: 'Start session',
      joinSession: 'Join session',
      readyToStart: 'Ready to start your session?',
      noticeOfVoicedRecording:
        'Session audio is recorded for safety and quality purposes. To learn more, see our {termsOfServiceLink}',
    },
  },
  userAgreement: {
    ageWarning:
      'If you are under the age of 18, you must have your parent or guardian read the agreement and agree to it for you.',
    buttons: {
      deleteAccount: 'Delete account',
    },
    decline: 'By declining, you won’t be able to have an account.',
    information:
      'In order for you to send and receive messages, Remind needs to collect your information, including your name, your school, your email, and your phone number.',
    informationAgreement:
      'You also agree to Remind collecting information about you in order to provide our service. This information may include your name, your school, your email, and your phone number.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    prompt: 'By proceeding, you agree to Remind’s {termsOfServiceLink} and {privacyPolicyLink}.',
    title: 'User agreement',
    willDelete: 'Your account will be deleted',
  },
  deviceList: {
    deviceIsRostered:
      "This device is rostered in your school or district's database. Contact your school or district administrator to remove.",
    remove: 'Remove device',
    isOnlyLogin: 'Add a different email address to remove this device',
  },
  peopleList: {
    actions: {
      newMessage: 'Message',
    },
  },
  messages: {
    buttons: {
      displayDeliverySummary: 'Display delivery summary',
      displayReactionsSummary: 'Display reactions summary',
      extraActions: 'Extra message actions',
    },
  },
  messageTemplates: {
    intendedFor: {
      classOwners: 'Class Owners',
      schoolAdmins: 'School Admins',
      districtAdmins: 'District Admins',
      unknown: 'Unknown',
    },
    filters: {
      allTemplates: 'All Templates',
      filteredTemplates: 'Filtered Templates',
      intendedFor: 'Intended for',
      ownedBy: 'Owned by',
    },
    buttons: {
      create: 'Create a Template',
      edit: 'Edit template',
      new: 'New Template',
    },
    toasts: {
      success: {
        create: 'Message Template successfully created',
        delete: 'Message template successfully deleted',
        duplicate: 'Message template successfully duplicated',
        update: 'Message template successfully updated',
      },
      error: {
        delete: "Couldn't delete message template, please contact support or try again later",
        update: "Couldn't update message template, please contact support or try again later",
        use: "Couldn't use message template, please contact support or try again later",
      },
    },
    view: {
      error: 'Sorry — no data is available at this time. Try refreshing the page.',
      noData: '{orgName} doesn’t have any templates yet.',
    },
    composer: {
      header: {
        creating: 'Add template content',
        editing: 'Editing the Template',
      },
      buttons: {
        label: 'Template',
        save: 'Save as a template',
        use: 'Use an existing template',
      },
    },
    dialogs: {
      createOrEdit: {
        title: 'Template details',
        titleCreate: 'Create a new template',
        input: {
          language: {
            placeholder: 'Select a language',
          },
          name: {
            title: 'Template Name',
            placeholder: 'Enter a name for your template',
            subtitle: 'Help you and others better find the template',
          },
          organization: {
            title: 'Owned by',
            placeholder: 'Choose an organization',
            subtitle: 'Other admins at this organization also manage this template',
          },
          availableTo: {
            title: 'Intended for',
            subtitle: 'Who will find this template useful at ',
          },
        },
      },
      delete: {
        title: 'Are you sure?',
        subtitle: 'Your organization will not be able to view or use this template once deleted.',
        actionButtonText: 'Delete',
      },
      select: {
        footer: 'Up to 10 results are shown, refine search for more results.',
        header: 'By most recently created',
        noOptions: 'No Message Templates found',
        placeholder: 'Type to search templates by name',
        title: 'Choose a template',
        confirm: {
          title: 'Are you sure?',
          subtitle: 'This action will replace the existing content you wrote and can’t be undone',
          actionButtonText: 'Replace with template',
        },
      },
    },
  },
  hideMessageDialog: {
    title: 'Are you sure?',
    announcementSection: {
      title: 'If you hide this announcement',
      bulletpoints: [
        'This announcement will no longer be visible to recipients in {groupName} in Remind.',
        'Delivered phone calls, emails, texts and their inserted links cannot be hidden. However, attachments will no longer be accessible.',
      ],
    },
    keepInMindSection: {
      title: 'Keep in mind',
      bulletpoints: [
        'If you sent this announcement to additional districts, schools or classes, you will need to hide those announcements separately from this one.',
        'Posts in social media need to be removed separately.',
        'Hidden class announcements can still be viewed in the message history pdf.',
        'The delivery summary will no longer be accessible.',
        'This action cannot be undone.',
      ],
    },
    buttons: {
      hideMessage: 'Hide this message',
    },
    toasts: {
      success: 'Announcement successfully hidden.',
    },
  },
  composer: {
    urgentMessageConfirmDialog: {
      title: {
        scheduled: 'Schedule this urgent message to be sent to {totalRecipientCount} people?',
        unscheduled: 'Send this urgent message to {totalRecipientCount} people?',
      },
      bulletpoints: [
        'Everyone will be sent a text, email, and app notification if available.',
        'Landlines will receive a text-to-voice call or the voice clip if attached.',
      ],
      callAllDevices: {
        checkboxLabel: 'Call all phone numbers',
        checkboxSubtext: 'Phones will receive a call in addition to the text message.',
        checkboxRecommendation: 'Not recommended; redundant messages reduce engagement.',
      },
    },
  },
  conversationComposer: {
    messageBodyInput: {
      placeholderText: 'Type your message',
    },
    translateButton: {
      tooltip: 'Translate',
    },
    translateMenu: {
      checkboxLabel: 'Translate this message',
      disabledRowTooltip: 'Type message text to view translation',
      noPreference: 'No preference set',
      original: 'Original',
      edited: 'Edited',
      recipient: {
        plural: 'recipients',
        singular: 'recipient',
      },
    },
    translationIntent: {
      description: {
        autotranslated: 'Autotranslated from original',
        edited: 'Edit',
        off: 'Turn this translation off',
      },
    },
  },
  organizations: {
    orgHeaders: {
      attachments: 'Attachments',
      messageTemplates: 'Message templates',
      surveys: 'Surveys',
    },
  },
} as const;

const messages = flatten(strings) as Record<string, string>;
export default messages;
